import { render, staticRenderFns } from "./cDocumentDashboardPartIssues.vue?vue&type=template&id=8e64d37e&scoped=true"
import script from "./cDocumentDashboardPartIssues.vue?vue&type=script&lang=js"
export * from "./cDocumentDashboardPartIssues.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDashboardPartIssues.vue?vue&type=style&index=0&id=8e64d37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e64d37e",
  null
  
)

export default component.exports